import React, { useEffect, useState } from "react";
import { MetaTags } from "react-meta-tags";
import { Form, Formik } from "formik";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import Switch from "react-switch";
import banner from "../../../src/assets/images/coupon.png";
import { getSkuCode } from "services/ecommerce/product.service";
import Select from "react-select";
import * as Yup from "yup";
import "./couponStyles.scss";
import { createcoupon, updateCoupon } from "services/coupons.service";
import { getServices } from "services/services.service";
import csc from "countries-states-cities";
import getImageUrl from "utils/getImageUrl";
import formatBytes from "utils/formatBytes";
import ProfileImage from "components/profileImage";
import Dropzone from "react-dropzone";
import { getProducts } from "services/ecommerce/product.service";
import SweetAlert from "react-bootstrap-sweetalert";
import Spinner from "components/spinner";
import moment from "moment";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { RadioButton } from "components/RadioButton";
import _ from "lodash";
import { getCategories } from "services/category.service";
import { getParentCategories } from "services/parentcategory.service";

const defaultValues = {
  type: "",
  title: "",
  code: "",
  discountType: "",
  discountAmount: "",
  minimumPurchase: "",
  startDate: "",
  endDate: "",
  startAppointmentDate: "",
  endAppointmentDate: "",
  serviceId: "",
  productId: "",
  serviceOne: "",
  serviceTwo: "",
  country: "",
  bannerImage: "",
  couponLogo: "",
  couponBannerWeb: "",
  status: "",
  description: "",
  whereUsed: "",
  usage: "",
  visibility: "",
  isDisplayInHomePage: false,
};

const CreateCoupon = ({ modal, toggle, coupondata, reload }) => {
  console.log(coupondata, "coupondata");
  const [couponCode, setcouponCode] = useState();
  const [createmodal, setCreateModal] = useState(modal);
  const [selectedType, setSelectedType] = useState("");
  const [selectedDiscountType, setselectedDiscountType] = useState(null);
  const [selectedCouponStatus, setselectedCouponStatus] = useState(null);
  const [values, setValues] = useState(defaultValues);
  const [selectedService, setSelectedService] = useState(null);
  const [Categories, setCategories] = useState([]);
  const [parentCategories, setParentCategories] = useState([]);
  console.log(parentCategories, "parent cc");
  const [selectedServiceOne, setSelectedServiceOne] = useState(null);
  const [selectedServiceTwo, setSelectedServiceTwo] = useState(null);
  const [selectedDiscountTypeForBuy1get1, setSelectedDiscountTypeForBuy1get1] =
    useState({});
  const [
    selectedDiscountPercentageForBuy1get1,
    setSelectedDiscountPercentageForBuy1get1,
  ] = useState("");
  const [descriptionForBuy1get1, setDescriptionForBuy1get1] = useState("");
  const [
    selectedDiscountTypeForFirstOrder,
    setSelectedDiscountTypeForFirstOrder,
  ] = useState({});
  const [
    selectedDiscountPercentageForFirstOrder,
    setSelectedDiscountPercentageForFirstOrder,
  ] = useState("");
  const [descriptionForFirstOrder, setDescriptionForFirstOrder] = useState("");
  const [minPurchaseForFirstOrder, setMinPurchaseForFirstOrder] = useState("");
  const [
    selectedDiscountTypeForDisOnService,
    setSelectedDiscountTypeForDisOnService,
  ] = useState({});
  const [
    selectedDiscountPercentageForDisOnService,
    setSelectedDiscountPercentageForDisOnService,
  ] = useState("");
  const [descriptionForDisOnService, setDescriptionForDisOnService] =
    useState("");
  const [minPurchaseForDisOnService, setMinPurchaseForDisOnService] =
    useState("");
  const [
    selectedDiscountTypeForDisOnCategory,
    setSelectedDiscountTypeForDisOnCategory,
  ] = useState({});
  const [
    selectedDiscountPercentageForDisOnCategory,
    setSelectedDiscountPercentageForDisOnCategory,
  ] = useState("");
  const [descriptionForDisOnCategory, setDescriptionForDisOnCategory] =
    useState("");
  const [minPurchaseForDisOnCategory, setMinPurchaseForDisOnCategory] =
    useState("");

  const [
    selectedDiscountTypeForDisOnParentCat,
    setSelectedDiscountTypeForDisOnParentCat,
  ] = useState({});
  const [
    selectedDiscountPercentageForDisOnParentCat,
    setSelectedDiscountPercentageForDisOnParentCat,
  ] = useState("");
  const [descriptionForDisOnParentCat, setDescriptionForDisOnParentCat] =
    useState("");
  const [minPurchaseForDisOnParentCat, setMinPurchaseForDisOnParentCat] =
    useState("");
  const [selectedDiscountTypeForGeneral, setSelectedDiscountTypeForGeneral] =
    useState({});
  const [
    selectedDiscountPercentageForGeneral,
    setSelectedDiscountPercentageForGeneral,
  ] = useState("");
  const [descriptionForGeneral, setDescriptionForGeneral] = useState("");
  const [minPurchaseForGeneral, setMinPurchaseForGeneral] = useState("");
  const [selectedProduct, setSelectedProduct] = useState({});
  const [services, setServices] = useState([]);
  const [categoryId, setCategoryId] = useState([]);
  const [parentCategoryId, setParentCategoryId] = useState([]);
  const [isHomeScreen, setIsHomeScreen] = useState(false);
  const [products, setProducts] = useState([]);
  const typeFilterOptions = ["Male", "Female"];
  const [typeFilter, setTypeFilter] = useState([]);
  const [countriesList, setCountriesList] = useState([]);
  const [selectedusage, setselectedUsage] = useState({
    label: "Single-Use",
    value: "Single-Use",
  });
  const [selectedCountry, setSelectedCountry] = useState({
    value: "IN",
    id: 101,
    label: "India",
  });
  console.log(selectedCountry, "selectedCountry");
  const [selectedVisibility, setSelectedVisibility] = useState({
    label: "Public",
    value: "Public",
  });
  const [logo, setLogo] = useState();
  const [webpageBanner, setWebpageBanner] = useState();
  const [mobilebanner, setMobilebanner] = useState();
  const [loading, setLoading] = useState(false);
  const [success_msg, setsuccess_msg] = useState(false);
  const [error_msg, seterror_msg] = useState(false);
  const [tempList, setTempList] = useState([]);
  const [catTempList, setCatTempList] = useState([]);
  const [parentCatTempList, setParentCatTempList] = useState([]);

  useEffect(() => {
    getAllServices();
    getAllProducts();
    setCreateModal(modal);
    getAllCategories();
    getAllParentCategories();
  }, []);
  const generateRandomCode = () => {
    getSkuCode()
      .then(res => {
        setcouponCode(res?.data);
        setValues({ ...values, ["code"]: couponCode });
      })
      .catch(err => console.log(err));
  };

  useEffect(() => {
    let list = [];
    csc.getAllCountries().forEach(ele => {
      let obj = {
        value: ele.iso2,
        id: ele.id,
        label: ele.name,
      };
      list.push(obj);
    });
    setCountriesList(list);
  }, []);
  useEffect(() => {
    if (coupondata) {
      if (coupondata?.type === "Buy One Get One Free") {
        setSelectedDiscountTypeForBuy1get1({
          value: coupondata.discountType,
          label: coupondata.discountType,
        });
        setSelectedDiscountPercentageForBuy1get1(coupondata?.discountAmount);
        setDescriptionForBuy1get1(coupondata?.description);
      } else if (coupondata?.type === "First Order") {
        setSelectedDiscountTypeForFirstOrder({
          value: coupondata.discountType,
          label: coupondata.discountType,
        });
        setSelectedDiscountPercentageForFirstOrder(coupondata?.discountAmount);
        setMinPurchaseForFirstOrder(coupondata?.minimumPurchase);
        setDescriptionForFirstOrder(coupondata?.description);
      } else if (coupondata?.type === "Discount On Service") {
        setSelectedDiscountTypeForDisOnService({
          value: coupondata.discountType,
          label: coupondata.discountType,
        });
        setSelectedDiscountPercentageForDisOnService(
          coupondata?.discountAmount
        );
        setMinPurchaseForDisOnService(coupondata?.minimumPurchase);
        setDescriptionForDisOnService(coupondata?.description);
      } else if (coupondata?.type === "Discount On Parent Category") {
        setSelectedDiscountTypeForDisOnParentCat({
          value: coupondata.discountType,
          label: coupondata.discountType,
        });
        setSelectedDiscountPercentageForDisOnParentCat(
          coupondata?.discountAmount
        );
        setMinPurchaseForDisOnParentCat(coupondata?.minimumPurchase);
        setDescriptionForDisOnParentCat(coupondata?.description);
      } else if (coupondata?.type === "Discount On Category") {
        setSelectedDiscountTypeForDisOnCategory({
          value: coupondata.discountType,
          label: coupondata.discountType,
        });
        setSelectedDiscountPercentageForDisOnCategory(
          coupondata?.discountAmount
        );
        setMinPurchaseForDisOnCategory(coupondata?.minimumPurchase);
        setDescriptionForDisOnCategory(coupondata?.description);
      } else if (coupondata?.type === "General") {
        setSelectedDiscountTypeForGeneral({
          value: coupondata.discountType,
          label: coupondata.discountType,
        });
        setSelectedDiscountPercentageForGeneral(coupondata?.discountAmount);
        setMinPurchaseForGeneral(coupondata?.minimumPurchase);
        setDescriptionForGeneral(coupondata?.description);
      }
    }
  }, [coupondata]);
  function handleSelectCountry(event) {
    setValues({ ...values, ["country"]: event.value });
    setSelectedCountry(event);
  }

  const DiscountTypeList = [
    {
      label: "Amount",
      value: "Amount",
    },
    {
      label: "Percentage",
      value: "Percentage",
    },
  ];
  const Usagelist = [
    {
      label: "Single-Use",
      value: "Single-Use",
    },
    {
      label: "Multiple-Use",
      value: "Multiple-Use",
    },
  ];
  const CouponStatusList = [
    {
      label: "Active",
      value: "Active",
    },
    {
      label: "Inactive",
      value: "Inactive",
    },
  ];
  const visibilityList = [
    {
      label: "Public",
      value: "Public",
    },
    {
      label: "Private",
      value: "Private",
    },
  ];
  const initialValues = coupondata
    ? { ...defaultValues, ...coupondata }
    : defaultValues;

  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Please Enter title"),
  });

  const handleSelectType = event => {
    const selectedValue = event.target.value;
    setSelectedType(selectedValue);
    setValues({ ...values, type: selectedValue });
    setSelectedService(null);
  };

  function handleSelectDiscountType(event) {
    setValues({ ...values, ["discountType"]: event.value });
    setselectedDiscountType(event);
  }
  function handleSelectVisibility(event) {
    setValues({ ...values, ["visibility"]: event.value });
    setSelectedVisibility(event);
  }
  function handleSelectCouponStatus(event) {
    setValues({ ...values, ["status"]: event.value });
    setselectedCouponStatus(event);
  }
  function handleSelectusage(event) {
    setValues({ ...values, ["usage"]: event.value });
    setselectedUsage(event);
  }
  const leaveToList = () => {
    toggle();
    setsuccess_msg(false);
    seterror_msg(false);
    setValues(defaultValues);
    setSelectedCountry({});
    // setSelectedProduct({});
    setSelectedService(null);
    setSelectedType({});
    setselectedDiscountType({});
    setSelectedVisibility({});
    setselectedCouponStatus({});
    setSelectedServiceOne(null);
    setSelectedServiceTwo(null);
    setSelectedDiscountTypeForBuy1get1({});
    setSelectedDiscountPercentageForBuy1get1("");
    setDescriptionForBuy1get1("");
    setSelectedDiscountTypeForFirstOrder({});
    setSelectedDiscountPercentageForFirstOrder("");
    setDescriptionForFirstOrder("");
    setMinPurchaseForFirstOrder("");
    setSelectedDiscountTypeForDisOnService({});
    setSelectedDiscountPercentageForDisOnService("");
    setDescriptionForDisOnService("");
    setMinPurchaseForDisOnService("");
    setSelectedDiscountTypeForDisOnCategory({});
    setSelectedDiscountPercentageForDisOnCategory("");
    setDescriptionForDisOnCategory("");
    setMinPurchaseForDisOnCategory("");
    setCategoryId({});
    setSelectedDiscountTypeForDisOnParentCat({});
    setSelectedDiscountPercentageForDisOnParentCat("");
    setDescriptionForDisOnParentCat("");
    setMinPurchaseForDisOnParentCat("");
    setParentCategoryId({});
    setSelectedDiscountTypeForGeneral({});
    setSelectedDiscountPercentageForGeneral("");
    setDescriptionForGeneral("");
    setMinPurchaseForGeneral("");
    setLogo("");
    setWebpageBanner("");
    setMobilebanner("");
    setcouponCode("");
  };
  const onCancel = () => {
    setValues(defaultValues);
    setSelectedCountry({});
    // setSelectedProduct({});
    setSelectedService(null);
    setSelectedType({});
    setselectedDiscountType({});
    setSelectedVisibility({});
    setselectedCouponStatus({});
    setSelectedServiceOne(null);
    setSelectedServiceTwo(null);
    setSelectedDiscountTypeForBuy1get1({});
    setSelectedDiscountPercentageForBuy1get1("");
    setDescriptionForBuy1get1("");
    setSelectedDiscountTypeForFirstOrder({});
    setSelectedDiscountPercentageForFirstOrder("");
    setDescriptionForFirstOrder("");
    setMinPurchaseForFirstOrder("");
    setSelectedDiscountTypeForDisOnService({});
    setSelectedDiscountPercentageForDisOnService("");
    setDescriptionForDisOnService("");
    setMinPurchaseForDisOnService("");
    setSelectedDiscountTypeForDisOnCategory({});
    setSelectedDiscountPercentageForDisOnCategory("");
    setDescriptionForDisOnCategory("");
    setMinPurchaseForDisOnCategory("");
    setCategoryId({});
    setSelectedDiscountTypeForDisOnParentCat({});
    setSelectedDiscountPercentageForDisOnParentCat("");
    setDescriptionForDisOnParentCat("");
    setMinPurchaseForDisOnParentCat("");
    setParentCategoryId({});
    setSelectedDiscountTypeForGeneral({});
    setSelectedDiscountPercentageForGeneral("");
    setDescriptionForGeneral("");
    setMinPurchaseForGeneral("");
    setLogo("");
    setWebpageBanner("");
    setMobilebanner("");
    setcouponCode("");
  };
  const onSubmit = values => {
    if (coupondata) {
      editChanges(values);
    } else {
      saveChanges(values);
    }
  };

  const buildOptionsProducts = list => {
    const result = list?.map(ele => {
      let obj = {
        label: ele.name,
        value: ele.name,
        id: ele?._id,
      };
      return obj;
    });
    return result;
  };
  const buildOptions = list => {
    // console.log(list, "list");
    return list?.map(ele => ({
      label: ele?.name,
      value: ele?.name,
      id: ele?._id,
      type: ele?.type,
      subCatid: ele?.categories?._id,
    }));
  };
  const buildOptionsCategories = list => {
    return list?.map(ele => ({
      label: ele?.name,
      value: ele?.name,
      id: ele?._id,
      type: ele?.type,
      parentCategoryId: ele?.parentCategory?._id,
    }));
  };
  const buildOptionsParentCategories = list => {
    // console.log(list, "list");
    return list?.map(ele => ({
      label: ele?.name,
      value: ele?.name,
      id: ele?._id,
      type: ele?.type,
    }));
  };
  const getColor = type => {
    if (type === "Female") return "#dd0a6c";
    if (type === "Male") return "#0c9ab5";
    return "black";
  };
  const getAllServices = () => {
    getServices()
      .then(res => {
        if (res) {
          let ActiveServices = res?.data.filter(
            ele => ele?.status === "Active" || ele?.status === "active"
          );
          console.log(
            res?.data,
            "<= services",
            ActiveServices,
            "<= ActiveServices"
          );
          setServices(buildOptions(ActiveServices));
          setTempList(buildOptions(ActiveServices));
        }
      })
      .catch(e => {
        console.log(e);
      });
  };
  const getAllCategories = () => {
    getCategories()
      .then(res => {
        if (res) {
          let ActiveServices = res?.filter(
            ele => ele?.status === "Active" || ele?.status === "active"
          );
          setCategories(buildOptionsCategories(ActiveServices));
          setCatTempList(buildOptionsCategories(ActiveServices));
        }
      })
      .catch(e => {
        console.log(e);
      });
  };
  const getAllParentCategories = () => {
    getParentCategories()
      .then(res => {
        if (res) {
          let ActiveServices = res?.data;
          setParentCategories(buildOptionsParentCategories(ActiveServices));
          setParentCatTempList(buildOptionsParentCategories(ActiveServices));
        }
      })
      .catch(e => {
        console.log(e);
      });
  };
  const getAllProducts = () => {
    getProducts()
      .then(res => {
        if (res) {
          setProducts(buildOptionsProducts(res?.data));
        }
      })
      .catch(e => {
        console.log(e);
      });
  };
  const saveChanges = values => {
    setLoading(true);
    let body = {
      type: selectedType,
      title: values?.title,
      code: couponCode
        ? couponCode?.toUpperCase()
        : values?.code?.toUpperCase(),

      startDate: values?.startDate,
      endDate: values?.endDate,
      startAppointmentDate: values?.startAppointmentDate,
      endAppointmentDate: values.endAppointmentDate,
      country: selectedCountry?.value,
      bannerImage: logo,
      status: selectedCouponStatus?.value,
      usage: selectedusage?.value,
      visibility: selectedVisibility?.value,
      webBanner: webpageBanner ? webpageBanner : "",
      mobileBanner: mobilebanner ? mobilebanner : "",
      isDisplayInHomePage: isHomeScreen,
      whereUsed: values?.whereUsed ? values?.whereUsed : "",
    };
    if (selectedType === "Buy One Get One Free") {
      {
        (body.discountType = selectedDiscountTypeForBuy1get1?.value),
          (body.discountAmount = selectedDiscountPercentageForBuy1get1),
          (body.description = descriptionForBuy1get1);
      }
    } else if (selectedType === "First Order") {
      {
        (body.discountType = selectedDiscountTypeForFirstOrder?.value),
          (body.discountAmount = selectedDiscountPercentageForFirstOrder),
          (body.description = descriptionForFirstOrder),
          (body.minimumPurchase = minPurchaseForFirstOrder);
      }
    } else if (selectedType === "Discount On Service") {
      {
        (body.discountType = selectedDiscountTypeForDisOnService?.value),
          (body.discountAmount = selectedDiscountPercentageForDisOnService),
          (body.minimumPurchase = minPurchaseForDisOnService),
          (body.description = descriptionForDisOnService);
      }
    } else if (selectedType === "Discount On Parent Category") {
      {
        (body.discountType = selectedDiscountTypeForDisOnParentCat?.value),
          (body.discountAmount = selectedDiscountPercentageForDisOnParentCat),
          (body.minimumPurchase = minPurchaseForDisOnParentCat),
          (body.description = descriptionForDisOnParentCat);
      }
    } else if (selectedType === "Discount On Category") {
      {
        (body.discountType = selectedDiscountTypeForDisOnCategory?.value),
          (body.discountAmount = selectedDiscountPercentageForDisOnCategory),
          (body.minimumPurchase = minPurchaseForDisOnCategory),
          (body.description = descriptionForDisOnCategory);
      }
    } else if (selectedType === "General") {
      {
        (body.discountType = selectedDiscountTypeForGeneral?.value),
          (body.discountAmount = selectedDiscountPercentageForGeneral),
          (body.minimumPurchase = minPurchaseForGeneral),
          (body.description = descriptionForGeneral);
      }
    }

    if (selectedService?.id) {
      body.serviceId = selectedService?.id;
      body.categoryId = selectedService?.subCatid;
    }

    if (selectedType === "Buy One Get One Free") {
      body.serviceId = selectedServiceOne?.id;
      body.categoryId = selectedServiceOne?.subCatid;
    }

    if (selectedType === "Buy One Get One Free") {
      body.serviceTwo = selectedServiceTwo?.id;
    }

    if (selectedType === "Discount On Parent Category") {
      body.parentCategoryId = parentCategoryId?.id;
      body.gender=parentCategoryId?.type
    }
    if (selectedType === "Discount On Category") {
      body.categoryId = categoryId?.id;
      body.parentCategoryId = categoryId?.parentCategoryId;
      body.gender=categoryId?.type
    }
    if (selectedProduct?.id) {
      body.productId = selectedProduct.id;
    }
    const ObjBody = JSON.stringify(body);
    console.log(ObjBody, "objBody");
    createcoupon(ObjBody)
      .then(res => {
        if (res?.success) {
          setsuccess_msg(true);
        } else {
          seterror_msg(true);
        }
        setLoading(false);
        reload();
      })
      .catch(e => {
        console.log(e);
        seterror_msg(true);
        setLoading(false);
      });
  };

  const editChanges = values => {
    setLoading(true);
    let body = {
      type: selectedType,
      title: values?.title,
      code: couponCode
        ? couponCode?.toUpperCase()
        : values?.code?.toUpperCase(),
      startDate: values?.startDate,
      endDate: values?.endDate,
      startAppointmentDate: values?.startAppointmentDate,
      endAppointmentDate: values.endAppointmentDate,
      country: selectedCountry?.value,
      bannerImage: logo,
      status: selectedCouponStatus.value,
      usage: selectedusage?.value,
      visibility: selectedVisibility?.value,
      webBanner: webpageBanner ? webpageBanner : "",
      mobileBanner: mobilebanner ? mobilebanner : "",
      isDisplayInHomePage: isHomeScreen,
      whereUsed: values?.whereUsed ? values?.whereUsed : "",
    };
    if (selectedType === "Buy One Get One Free") {
      {
        (body.discountType = selectedDiscountTypeForBuy1get1?.value),
          (body.discountAmount = selectedDiscountPercentageForBuy1get1),
          (body.description = descriptionForBuy1get1);
        // (body.serviceId) =
      }
    } else if (selectedType === "First Order") {
      {
        (body.discountType = selectedDiscountTypeForFirstOrder?.value),
          (body.discountAmount = selectedDiscountPercentageForFirstOrder),
          (body.description = descriptionForFirstOrder),
          (body.minimumPurchase = minPurchaseForFirstOrder);
      }
    } else if (selectedType === "Discount On Service") {
      {
        (body.discountType = selectedDiscountTypeForDisOnService?.value),
          (body.discountAmount = selectedDiscountPercentageForDisOnService),
          (body.minimumPurchase = minPurchaseForDisOnService),
          (body.description = descriptionForDisOnService);
      }
    } else if (selectedType === "Discount On Parent Category") {
      {
        (body.discountType = selectedDiscountTypeForDisOnParentCat?.value),
          (body.discountAmount = selectedDiscountPercentageForDisOnParentCat),
          (body.minimumPurchase = minPurchaseForDisOnParentCat),
          (body.description = descriptionForDisOnParentCat);
      }
    } else if (selectedType === "Discount On Category") {
      {
        (body.discountType = selectedDiscountTypeForDisOnCategory?.value),
          (body.discountAmount = selectedDiscountPercentageForDisOnCategory),
          (body.minimumPurchase = minPurchaseForDisOnCategory),
          (body.description = descriptionForDisOnCategory);
      }
    } else if (selectedType === "General") {
      {
        (body.discountType = selectedDiscountTypeForGeneral?.value),
          (body.discountAmount = selectedDiscountPercentageForGeneral),
          (body.minimumPurchase = minPurchaseForGeneral),
          (body.description = descriptionForGeneral);
      }
    }
    if (selectedService?.id) {
      body.serviceId = selectedService?.id;
      body.categoryId = selectedService?.subCatid;
    }

    if (selectedType === "Buy One Get One Free") {
      body.serviceId = selectedServiceOne?.id;
      body.categoryId = selectedServiceOne?.subCatid;
    }

    if (selectedType === "Buy One Get One Free") {
      body.serviceTwo = selectedServiceTwo?.id;
    }
    if (selectedProduct?.id) {
      body.productId = selectedProduct.id;
    }
    if (selectedType === "Discount On Parent Category") {
      body.parentCategoryId = parentCategoryId?.id;
      body.gender=parentCategoryId?.type
    }
    if (selectedType === "Discount On Category") {
      body.categoryId = categoryId?.id;
      body.parentCategoryId = categoryId?.parentCategoryId;
      body.gender=categoryId?.type
    }
    const ObjBody = JSON.stringify(body);
    console.log(ObjBody, "objBody");
    updateCoupon(coupondata?._id, ObjBody)
      .then(res => {
        if (res.success) {
          setsuccess_msg(true);
        } else {
          seterror_msg(true);
        }
        setLoading(false);
        reload();
      })
      .catch(e => {
        console.log(e);
        seterror_msg(true);
        setLoading(false);
      });
  };

  const successPopup = () => {
    return (
      <SweetAlert
        title="Success"
        success
        customButtons={
          <React.Fragment>
            <Button
              color="light"
              className="w-md btn-sm mx-1"
              onClick={leaveToList}
            >
              Ok
            </Button>
          </React.Fragment>
        }
      >
        {coupondata
          ? " Successfully Coupon Edited"
          : " Successfully Coupon Created"}
      </SweetAlert>
    );
  };

  const errorPopup = () => {
    return (
      <SweetAlert
        title="Failure"
        danger
        onConfirm={leaveToList}
        customButtons={
          <React.Fragment>
            <Button
              color="light"
              className="w-md btn-sm mx-1"
              onClick={leaveToList}
            >
              Ok
            </Button>
          </React.Fragment>
        }
      >
        Something went wrong
      </SweetAlert>
    );
  };
  function getcountryname(code) {
    const fullcountryname = countriesList?.filter(ele =>
      ele?.value?.includes(code)
    );
    return fullcountryname;
  }
  const handleCheckboxChange = text => {
    let indx = typeFilter.indexOf(text);
    if (indx >= 0) {
      typeFilter?.splice(indx, 1);
    } else {
      typeFilter?.push(text);
    }
    if (typeFilter.length > 0) {
      let newList = _.filter(tempList, function (obj) {
        if (typeFilter?.includes(obj?.type)) {
          return obj;
        }
      });
      setServices(newList);
    } else {
      setServices(tempList);
    }
    setTypeFilter(typeFilter);
  };
  const handleCheckboxChangeCategory = text => {
    let indx = typeFilter.indexOf(text);
    if (indx >= 0) {
      typeFilter?.splice(indx, 1);
    } else {
      typeFilter?.push(text);
    }
    if (typeFilter.length > 0) {
      let newList = _.filter(Categories, function (obj) {
        if (typeFilter?.includes(obj?.type)) {
          return obj;
        }
      });
      setCategories(newList);
    } else {
      setCategories(catTempList);
    }
    setTypeFilter(typeFilter);
  };
  const handleCheckboxChangeParentCategory = text => {
    let indx = typeFilter.indexOf(text);
    if (indx >= 0) {
      typeFilter?.splice(indx, 1);
    } else {
      typeFilter?.push(text);
    }
    if (typeFilter.length > 0) {
      let newList = _.filter(parentCategories, function (obj) {
        if (typeFilter?.includes(obj?.type)) {
          return obj;
        }
      });
      setParentCategories(newList);
    } else {
      setParentCategories(parentCatTempList);
    }
    setTypeFilter(typeFilter);
  };
  const checkboxItems = () => {
    return (
      <React.Fragment>
        {typeFilterOptions?.map((option, index) => {
          return (
            <div className="d-flex me-3 align-items-center" key={index}>
              <Input
                key={option}
                id={option}
                type="checkbox"
                className="form-check-Inpu me-2 cursor-pointer"
                onChange={() => handleCheckboxChange(option)}
              />
              <Label className="form-check-Label fw-bold mb-0  pt-1  cursor-pointer">
                {option}
              </Label>
            </div>
          );
        })}
      </React.Fragment>
    );
  };
  const checkboxItemsForCategoryFilters = () => {
    return (
      <React.Fragment>
        {typeFilterOptions?.map((option, index) => {
          return (
            <div className="d-flex me-3 align-items-center" key={index}>
              <Input
                key={option}
                id={option}
                type="checkbox"
                className="form-check-Inpu me-2 cursor-pointer"
                onChange={() => handleCheckboxChangeCategory(option)}
              />
              <Label className="form-check-Label fw-bold mb-0  pt-1  cursor-pointer">
                {option}
              </Label>
            </div>
          );
        })}
      </React.Fragment>
    );
  };
  const checkboxItemsForParentCategoryFilters = () => {
    return (
      <React.Fragment>
        {typeFilterOptions?.map((option, index) => {
          return (
            <div className="d-flex me-3 align-items-center" key={index}>
              <Input
                key={option}
                id={option}
                type="checkbox"
                className="form-check-Inpu me-2 cursor-pointer"
                onChange={() => handleCheckboxChangeParentCategory(option)}
              />
              <Label className="form-check-Label fw-bold mb-0  pt-1  cursor-pointer">
                {option}
              </Label>
            </div>
          );
        })}
      </React.Fragment>
    );
  };
  const handleSwitch = event => {
    setIsHomeScreen(event);
  };
  return (
    <>
      <Modal
        isOpen={modal}
        toggle={toggle}
        backdrop="static"
        size="xl"
        onClosed={() => {
          onCancel();
        }}
      >
        <ModalHeader toggle={toggle}>
          <div className="d-flex align-items-center">
            <div className="me-2">
              <img src={banner} alt="" width={30} />
            </div>
            <h5 className="fw-bold text-uppercase mb-0">Coupon setUp</h5>
          </div>
        </ModalHeader>
        <ModalBody className="bg-light">
          <Container fluid>
            <div>
              <div className="mt-3">
                <Card>
                  <CardBody>
                    <Formik
                      enableReinitialize
                      initialValues={initialValues}
                      validationSchema={validationSchema}
                      // onSubmit={onSubmit}
                    >
                      {({
                        errors,
                        touched,
                        isSubmitting,
                        setFieldValue,
                        handleChange,
                        values,
                      }) => {
                        useEffect(() => {
                          const getfullcountryname = getcountryname(
                            coupondata?.country
                          );
                          if (coupondata) {
                            setSelectedType(coupondata?.type);
                            setSelectedCountry({
                              value: coupondata.country,
                              label: getfullcountryname[0]?.label,
                            });
                            setSelectedProduct({
                              value: coupondata.productId?.name,
                              label: coupondata.productId?.name,
                              id: coupondata?.productId?._id,
                            });

                            setselectedCouponStatus({
                              value: coupondata?.status,
                              label: coupondata?.status,
                            });
                            setselectedUsage({
                              value: coupondata?.usage,
                              label: coupondata?.usage,
                            });
                            setSelectedVisibility({
                              value: coupondata?.visibility,
                              label: coupondata?.visibility,
                            });
                            setLogo(coupondata?.bannerImage);
                            setWebpageBanner(coupondata?.webBanner);
                            setMobilebanner(coupondata?.mobileBanner);
                            setIsHomeScreen(coupondata?.isDisplayInHomePage);

                            if (coupondata?.type === "Discount On Service") {
                              setSelectedService({
                                value: coupondata.serviceId?.name,
                                label: coupondata.serviceId?.name,
                                id: coupondata?.serviceId?._id,
                                type: coupondata?.serviceId?.type,
                              });
                            } else if (
                              coupondata?.type === "Discount On Parent Category"
                            ) {
                              // debugger
                              let Parentcategory = parentCategories?.filter(
                                ele => ele?.id === coupondata?.parentCategoryId
                              );
                              setParentCategoryId(Parentcategory[0]);
                            } else if (
                              coupondata?.type === "Discount On Category"
                            ) {
                              let category = Categories?.filter(
                                ele => ele?.id === coupondata?.categoryId
                              );
                              setCategoryId(category[0]);
                            } else if (
                              coupondata?.type === "Buy One Get One Free"
                            ) {
                              setSelectedServiceOne({
                                value: coupondata.serviceId?.name,
                                label: coupondata.serviceId?.name,
                                id: coupondata?.serviceId?._id,
                                type: coupondata?.serviceId?.type,
                              });
                              let serviceTwo = services?.filter(
                                ele => ele?.id === coupondata?.serviceTwo
                              );
                              setSelectedServiceTwo(serviceTwo[0]);
                            }
                          }
                        }, [coupondata]);

                        return (
                          <Form className="Discount_container">
                            <Row>
                              <Col md={4}>
                                <FormGroup>
                                  <Label for="title">Coupon Title</Label>
                                  <Input
                                    type="text"
                                    name="title"
                                    id="title"
                                    placeholder="Coupon Title"
                                    value={values?.title}
                                    onChange={event => {
                                      handleChange("title")(event.target.value);
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4}>
                                <FormGroup>
                                  <Label for="usage">Usage</Label>
                                  <Select
                                    id="usage"
                                    options={Usagelist || []}
                                    placeholder="Select..."
                                    value={selectedusage}
                                    onChange={event => {
                                      handleSelectusage(event);
                                      handleChange("usage")(event.value);
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4}>
                                <FormGroup>
                                  <Label for="visibility">Visibility</Label>
                                  <Select
                                    id="visibility"
                                    options={visibilityList || []}
                                    placeholder="Select..."
                                    value={selectedVisibility}
                                    onChange={event => {
                                      handleSelectVisibility(event);
                                      handleChange("visibility")(event.value);
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4}>
                                <FormGroup>
                                  <Label
                                    for="code"
                                    className="d-flex justify-content-between"
                                  >
                                    <div>Coupon Code </div>

                                    {selectedVisibility?.value === "Public" &&
                                    !couponCode ? (
                                      <Button
                                        className=" border border-0 p-0 px-2 text-info "
                                        color="light"
                                        role="button"
                                        onClick={() => generateRandomCode()}
                                      >
                                        Generate coupon code
                                      </Button>
                                    ) : (
                                      ""
                                    )}
                                  </Label>
                                  <Input
                                    type="text"
                                    name="code"
                                    id="code"
                                    placeholder="Coupon Code"
                                    value={
                                      couponCode
                                        ? couponCode?.toUpperCase()
                                        : values?.code.toUpperCase()
                                    }
                                    onChange={event => {
                                      handleChange("code")(event.target.value);
                                    }}
                                    // disabled={true}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4}>
                                <FormGroup>
                                  <Label for="startDate">Start Date</Label>
                                  <DatePicker
                                    name="startDate"
                                    selected={
                                      values?.startDate
                                        ? moment(
                                            values.startDate,
                                            "YYYY-MM-DD"
                                          ).toDate()
                                        : null
                                    }
                                    onChange={date => {
                                      const formattedDate =
                                        moment(date).format("YYYY-MM-DD");
                                      setFieldValue("startDate", formattedDate);
                                    }}
                                    dateFormat="dd-MMM-yyyy" // Display format
                                    className="form-control"
                                    autoComplete="off"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4}>
                                <FormGroup>
                                  <Label for="endDate">End Date</Label>
                                  <DatePicker
                                    name="endDate"
                                    selected={
                                      values?.endDate
                                        ? moment(
                                            values.endDate,
                                            "YYYY-MM-DD"
                                          ).toDate()
                                        : null
                                    }
                                    onChange={date => {
                                      const formattedDate =
                                        moment(date).format("YYYY-MM-DD");
                                      setFieldValue("endDate", formattedDate);
                                    }}
                                    dateFormat="dd-MMM-yyyy" // Display format
                                    className="form-control"
                                    autoComplete="off"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4}>
                                <FormGroup>
                                  <Label for="startAppointmentDate">
                                    Order Start Date
                                  </Label>
                                  <DatePicker
                                    name="startAppointmentDate"
                                    selected={
                                      values?.startAppointmentDate
                                        ? moment(
                                            values?.startAppointmentDate,
                                            "YYYY-MM-DD"
                                          ).toDate()
                                        : null
                                    }
                                    onChange={date => {
                                      const formattedDate =
                                        moment(date).format("YYYY-MM-DD");
                                      setFieldValue("startAppointmentDate", formattedDate);
                                    }}
                                    dateFormat="dd-MMM-yyyy" // Display format
                                    className="form-control"
                                    autoComplete="off"
                                    // disabled
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4}>
                                <FormGroup>
                                  <Label for="endAppointmentDate">
                                    Order End Date
                                  </Label>
                                  <DatePicker
                                    name="endAppointmentDate"
                                    selected={
                                      values?.endAppointmentDate
                                        ? moment(
                                            values.endAppointmentDate,
                                            "YYYY-MM-DD"
                                          ).toDate()
                                        : null
                                    }
                                    onChange={date => {
                                      const formattedDate =
                                        moment(date).format("YYYY-MM-DD");
                                      setFieldValue(
                                        "endAppointmentDate",
                                        formattedDate
                                      );
                                    }}
                                    dateFormat="dd-MMM-yyyy" // Display format
                                    className="form-control"
                                    autoComplete="off"
                                  />
                                </FormGroup>
                              </Col>
                              <Col sm={4} className="">
                                <Label htmlFor="country">Country</Label>
                                <Select
                                  name="country"
                                  id="country"
                                  onChange={event => {
                                    handleSelectCountry(event);
                                  }}
                                  options={countriesList}
                                  value={selectedCountry}
                                  classNamePrefix="select2-selection"
                                />
                              </Col>
                              <Col md={4}>
                                <FormGroup>
                                  <Label for="Status">Status</Label>
                                  <Select
                                    name="Status"
                                    id="Status"
                                    value={selectedCouponStatus}
                                    placeholder="Select..."
                                    onChange={event => {
                                      handleSelectCouponStatus(event);
                                      handleChange("status")(event.value);
                                    }}
                                    options={CouponStatusList}
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4} className="text-center">
                                <div className="d-flex align-items-center flex-wrap mt-4">
                                  <Switch
                                    onChange={event => handleSwitch(event)}
                                    checked={isHomeScreen}
                                    onColor="#86d3ff"
                                    onHandleColor="#2693e6"
                                    handleDiameter={25}
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    boxShadow="0px 1px 2px rgba(0, 0, 0, 0.6)"
                                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                    height={15}
                                    width={40}
                                    className="react-switch"
                                    id="material-switch"
                                  />
                                  <div>
                                    <h6 className="mb-0 ms-2">
                                      Is Display in Home Screen
                                    </h6>
                                  </div>
                                </div>
                              </Col>
                              <div className="p-3 border rounded">
                                <h5 className="mb-3">Select Coupon Type</h5>
                                <div>
                                  <div className="d-flex">
                                    <Col md={2}>
                                      <RadioButton
                                        id="Buy One Get One Free"
                                        isSelected={
                                          selectedType ===
                                          "Buy One Get One Free"
                                        }
                                        value={"Buy One Get One Free"}
                                        label={"Buy 1 Get 1"}
                                        changed={handleSelectType}
                                      />
                                    </Col>
                                  </div>
                                  <div
                                    className={`mt-2 p-3 border rounded ${
                                      selectedType !== "Buy One Get One Free"
                                        ? "discount_div_gray"
                                        : "discount_div_white"
                                    }`}
                                  >
                                    <Row>
                                      <div className="d-flex align-items-center flex-wrap">
                                        <div className="d-flex align-items-center flex-wrap mb-3">
                                          {checkboxItems()}
                                        </div>
                                        <div className="d-flex align-items-center flex-wrap mb-2">
                                          <div className="d-flex align-items-center flex-wrap">
                                            <i
                                              className="bx bxs-circle"
                                              style={{ color: "#0c9ab5" }}
                                            ></i>
                                            <p className="mb-0 ms-1">Male</p>
                                          </div>
                                          <div className="d-flex align-items-center flex-wrap ms-3">
                                            <i
                                              className="bx bxs-circle"
                                              style={{ color: "#dd0a6c" }}
                                            ></i>
                                            <p className="mb-0 ms-1">Female</p>
                                          </div>
                                        </div>
                                      </div>
                                      <Col md={4}>
                                        <FormGroup className="mb-0">
                                          <div>
                                            <Label>Service One</Label>
                                          </div>
                                          <Select
                                            name="Service One"
                                            placeholder="Select..."
                                            value={selectedServiceOne}
                                            onChange={event =>
                                              setSelectedServiceOne(event)
                                            }
                                            options={services}
                                            isDisabled={
                                              selectedType !==
                                              "Buy One Get One Free"
                                            }
                                            getOptionLabel={e => (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "8px",
                                                }}
                                              >
                                                {/* Dynamic Dot Color */}
                                                <span
                                                  style={{
                                                    width: "10px",
                                                    height: "10px",
                                                    borderRadius: "50%",
                                                    backgroundColor: getColor(
                                                      e.type
                                                    ),
                                                    display: "inline-block",
                                                  }}
                                                ></span>
                                                {/* Service Name in Default Color */}
                                                <span
                                                  style={{ color: "inherit" }}
                                                >
                                                  {e.label}
                                                </span>
                                              </div>
                                            )}
                                            styles={{
                                              singleValue: provided => ({
                                                ...provided,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                              }),
                                              option: provided => ({
                                                ...provided,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                              }),
                                            }}
                                          />
                                          <Label className="statusValidation">
                                            {errors.type ? errors.type : ""}
                                          </Label>
                                        </FormGroup>
                                      </Col>
                                      <Col md={4}>
                                        <FormGroup className="mb-0">
                                          <Label>Service Two</Label>
                                          <Select
                                            name="serviceId"
                                            placeholder="Select..."
                                            value={selectedServiceTwo}
                                            onChange={event => {
                                              setSelectedServiceTwo(event);
                                            }}
                                            options={services}
                                            isDisabled={
                                              selectedType !==
                                              "Buy One Get One Free"
                                            }
                                            getOptionLabel={e => (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "8px",
                                                }}
                                              >
                                                {/* Dynamic Dot Color */}
                                                <span
                                                  style={{
                                                    width: "10px",
                                                    height: "10px",
                                                    borderRadius: "50%",
                                                    backgroundColor: getColor(
                                                      e.type
                                                    ),
                                                    display: "inline-block",
                                                  }}
                                                ></span>
                                                {/* Service Name in Default Color */}
                                                <span
                                                  style={{ color: "inherit" }}
                                                >
                                                  {e.label}
                                                </span>
                                              </div>
                                            )}
                                            styles={{
                                              singleValue: provided => ({
                                                ...provided,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                              }),
                                              option: provided => ({
                                                ...provided,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                              }),
                                            }}
                                          />
                                          <Label className="statusValidation">
                                            {errors.type ? errors.type : ""}
                                          </Label>
                                        </FormGroup>
                                      </Col>
                                      <Col md={4}>
                                        <FormGroup>
                                          <Label for="discountType">
                                            Discount Type
                                          </Label>
                                          <Select
                                            id="discountType"
                                            options={DiscountTypeList || []}
                                            value={
                                              selectedDiscountTypeForBuy1get1
                                            }
                                            onChange={event => {
                                              handleSelectDiscountType(event);
                                              setSelectedDiscountTypeForBuy1get1(
                                                event
                                              );
                                            }}
                                            isDisabled={
                                              selectedType !==
                                              "Buy One Get One Free"
                                            }
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md={4}>
                                        <FormGroup>
                                          <Label for="discountAmount">
                                            Discount Amount/Percentage
                                          </Label>
                                          <InputGroup>
                                            {selectedDiscountTypeForBuy1get1?.value !==
                                              "Percentage" && (
                                              <InputGroupText>
                                                INR
                                              </InputGroupText>
                                            )}

                                            <Input
                                              type="text"
                                              name="discountAmount"
                                              id="discountAmount"
                                              placeholder={
                                                selectedDiscountTypeForBuy1get1?.value ===
                                                "Percentage"
                                                  ? "Discount percentage"
                                                  : "Discount Amount"
                                              }
                                              value={
                                                selectedDiscountPercentageForBuy1get1
                                              }
                                              onChange={event => {
                                                setSelectedDiscountPercentageForBuy1get1(
                                                  event.target.value
                                                );
                                              }}
                                              disabled={
                                                selectedType !==
                                                "Buy One Get One Free"
                                              }
                                            />
                                            {selectedDiscountType?.value ===
                                              "Percentage" && (
                                              <InputGroupText>%</InputGroupText>
                                            )}
                                          </InputGroup>
                                        </FormGroup>
                                      </Col>
                                      <div className="">
                                        <Label for="description">
                                          Description (<i>max 70 characters</i>)
                                        </Label>
                                        <div>
                                          <CKEditor
                                            editor={ClassicEditor}
                                            data={descriptionForBuy1get1}
                                            onChange={(event, editor) => {
                                              const data = editor.getData();
                                              let plainText = data.replace(
                                                /<[^>]*>/g,
                                                ""
                                              );
                                              if (plainText?.length <= 70) {
                                                setDescriptionForBuy1get1(data);
                                              } else {
                                                editor.setData(
                                                  descriptionForBuy1get1
                                                );
                                              }
                                            }}
                                            disabled={
                                              selectedType !==
                                              "Buy One Get One Free"
                                            }
                                          />
                                        </div>
                                      </div>
                                    </Row>
                                  </div>
                                </div>
                                <div>
                                  <div className="mt-3">
                                    <Col md={3}>
                                      <RadioButton
                                        id="First Order"
                                        isSelected={
                                          selectedType === "First Order"
                                        }
                                        value={"First Order"}
                                        label={"First Order"}
                                        changed={handleSelectType}
                                      />
                                    </Col>
                                  </div>
                                  <div
                                    className={`mt-2 p-3 border rounded ${
                                      selectedType !== "First Order"
                                        ? "discount_div_gray"
                                        : "discount_div_white"
                                    }`}
                                  >
                                    {/* <h6>First Order - Select Two Services</h6> */}
                                    <Row>
                                      <Col md={4}>
                                        <FormGroup>
                                          <Label for="discountType">
                                            Discount Type
                                          </Label>
                                          <Select
                                            id="discountType"
                                            options={DiscountTypeList || []}
                                            value={
                                              selectedDiscountTypeForFirstOrder
                                            }
                                            onChange={event => {
                                              handleSelectDiscountType(event);
                                              // handleChange("discountType")(
                                              //   event.value
                                              // );
                                              setSelectedDiscountTypeForFirstOrder(
                                                event
                                              );
                                            }}
                                            isDisabled={
                                              selectedType !== "First Order"
                                            }
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md={4}>
                                        <FormGroup>
                                          <Label for="discountAmount">
                                            Discount Amount/Percentage
                                          </Label>
                                          <InputGroup>
                                            {/* Prefix: INR or Percentage Symbol */}
                                            {selectedDiscountTypeForFirstOrder?.value !==
                                              "Percentage" && (
                                              <InputGroupText>
                                                INR
                                              </InputGroupText>
                                            )}

                                            <Input
                                              type="text"
                                              name="discountAmount"
                                              id="discountAmount"
                                              placeholder={
                                                selectedDiscountTypeForFirstOrder?.value ===
                                                "Percentage"
                                                  ? "Discount percentage"
                                                  : "Discount Amount"
                                              }
                                              value={
                                                selectedDiscountPercentageForFirstOrder
                                              }
                                              onChange={event => {
                                                // handleChange("discountAmount")(
                                                //   event.target.value
                                                // );
                                                setSelectedDiscountPercentageForFirstOrder(
                                                  event.target.value
                                                );
                                              }}
                                              disabled={
                                                selectedType !== "First Order"
                                              }
                                            />

                                            {/* Suffix: % Symbol if Percentage is selected */}
                                            {selectedDiscountTypeForFirstOrder?.value ===
                                              "Percentage" && (
                                              <InputGroupText>%</InputGroupText>
                                            )}
                                          </InputGroup>
                                        </FormGroup>
                                      </Col>
                                      <Col md={4}>
                                        <FormGroup>
                                          <Label for="minimumPurchase">
                                            Minimum Purchase Required
                                          </Label>
                                          <InputGroup>
                                            <InputGroupText>INR</InputGroupText>
                                            <Input
                                              type="text"
                                              name="minimumPurchase"
                                              id="minimumPurchase"
                                              placeholder="Minimum Purchase"
                                              value={minPurchaseForFirstOrder}
                                              onChange={event => {
                                                // handleChange("minimumPurchase")(
                                                //   event.target.value
                                                // );
                                                setMinPurchaseForFirstOrder(
                                                  event.target.value
                                                );
                                              }}
                                              disabled={
                                                selectedType !== "First Order"
                                              }
                                            />
                                          </InputGroup>
                                        </FormGroup>
                                      </Col>
                                      <div className="">
                                        <Label for="description">
                                          Description (<i>max 70 characters</i>)
                                        </Label>
                                        <div>
                                          <CKEditor
                                            // key={descriptionForFirstOrder}
                                            editor={ClassicEditor}
                                            data={descriptionForFirstOrder}
                                            onChange={(event, editor) => {
                                              const data = editor.getData();
                                              let plainText = data.replace(
                                                /<[^>]*>/g,
                                                ""
                                              );
                                              if (plainText.length <= 70) {
                                                setDescriptionForFirstOrder(
                                                  data
                                                );
                                              } else {
                                                editor.setData(
                                                  descriptionForBuy1get1
                                                );
                                              }
                                            }}
                                            disabled={
                                              selectedType !== "First Order"
                                            }
                                          />
                                        </div>
                                      </div>
                                    </Row>
                                  </div>
                                </div>
                                <div>
                                  <div className="mt-3 d-flex">
                                    <Col md={2}>
                                      <RadioButton
                                        id="Discount On Service"
                                        isSelected={
                                          selectedType === "Discount On Service"
                                        }
                                        value={"Discount On Service"}
                                        label={"Discount On Service"}
                                        changed={handleSelectType}
                                      />
                                    </Col>
                                  </div>
                                  <div
                                    className={`mt-2 p-3 border rounded ${
                                      selectedType !== "Discount On Service"
                                        ? "discount_div_gray"
                                        : "discount_div_white"
                                    }`}
                                  >
                                    {/* <h6>First Order - Select Two Services</h6> */}
                                    <Row>
                                      <div className="d-flex align-items-center flex-wrap">
                                        <div className="d-flex align-items-center flex-wrap mb-3">
                                          {checkboxItems()}
                                        </div>
                                        <div className="d-flex align-items-center flex-wrap mb-2">
                                          <div className="d-flex align-items-center flex-wrap">
                                            <i
                                              className="bx bxs-circle"
                                              style={{ color: "#0c9ab5" }}
                                            ></i>
                                            <p className="mb-0 ms-1">Male</p>
                                          </div>
                                          <div className="d-flex align-items-center flex-wrap ms-3">
                                            <i
                                              className="bx bxs-circle"
                                              style={{ color: "#dd0a6c" }}
                                            ></i>
                                            <p className="mb-0 ms-1">Female</p>
                                          </div>
                                        </div>
                                      </div>
                                      <Col md={4}>
                                        <FormGroup>
                                          <Label>Select Service</Label>
                                          <Select
                                            name="serviceId"
                                            placeholder="Select..."
                                            value={selectedService}
                                            onChange={event => {
                                              setSelectedService(event);
                                            }}
                                            options={services}
                                            isDisabled={
                                              selectedType !==
                                              "Discount On Service"
                                            }
                                            getOptionLabel={e => (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "8px",
                                                }}
                                              >
                                                {/* Dynamic Dot Color */}
                                                <span
                                                  style={{
                                                    width: "10px",
                                                    height: "10px",
                                                    borderRadius: "50%",
                                                    backgroundColor: getColor(
                                                      e.type
                                                    ),
                                                    display: "inline-block",
                                                  }}
                                                ></span>
                                                {/* Service Name in Default Color */}
                                                <span
                                                  style={{ color: "inherit" }}
                                                >
                                                  {e.label}
                                                </span>
                                              </div>
                                            )}
                                            styles={{
                                              singleValue: provided => ({
                                                ...provided,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                              }),
                                              option: provided => ({
                                                ...provided,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                              }),
                                            }}
                                          />
                                          <Label className="statusValidation">
                                            {errors.type ? errors.type : ""}
                                          </Label>
                                        </FormGroup>
                                      </Col>

                                      <Col md={4}>
                                        <FormGroup>
                                          <Label for="discountType">
                                            Discount Type
                                          </Label>
                                          <Select
                                            id="discountType"
                                            options={DiscountTypeList || []}
                                            value={
                                              selectedDiscountTypeForDisOnService
                                            }
                                            onChange={event => {
                                              handleSelectDiscountType(event);
                                              // handleChange("discountType")(
                                              //   event.value
                                              // );
                                              setSelectedDiscountTypeForDisOnService(
                                                event
                                              );
                                            }}
                                            isDisabled={
                                              selectedType !==
                                              "Discount On Service"
                                            }
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md={4}>
                                        <FormGroup>
                                          <Label for="discountAmount">
                                            Discount Amount/Percentage
                                          </Label>
                                          <InputGroup>
                                            {/* Prefix: INR or Percentage Symbol */}
                                            {selectedDiscountTypeForDisOnService?.value !==
                                              "Percentage" && (
                                              <InputGroupText>
                                                INR
                                              </InputGroupText>
                                            )}

                                            <Input
                                              type="text"
                                              name="discountAmount"
                                              id="discountAmount"
                                              placeholder={
                                                selectedDiscountTypeForDisOnService?.value ===
                                                "Percentage"
                                                  ? "Discount percentage"
                                                  : "Discount Amount"
                                              }
                                              value={
                                                selectedDiscountPercentageForDisOnService
                                              }
                                              onChange={event => {
                                                // handleChange("discountAmount")(
                                                //   event.target.value
                                                // );
                                                setSelectedDiscountPercentageForDisOnService(
                                                  event.target.value
                                                );
                                              }}
                                              disabled={
                                                selectedType !==
                                                "Discount On Service"
                                              }
                                            />

                                            {/* Suffix: % Symbol if Percentage is selected */}
                                            {selectedDiscountTypeForDisOnService?.value ===
                                              "Percentage" && (
                                              <InputGroupText>%</InputGroupText>
                                            )}
                                          </InputGroup>
                                        </FormGroup>
                                      </Col>
                                      <Col md={4}>
                                        <FormGroup>
                                          <Label for="minimumPurchase">
                                            Minimum Purchase Required
                                          </Label>
                                          <InputGroup>
                                            <InputGroupText>INR</InputGroupText>
                                            <Input
                                              type="text"
                                              name="minimumPurchase"
                                              id="minimumPurchase"
                                              placeholder="Minimum Purchase"
                                              value={minPurchaseForDisOnService}
                                              onChange={event => {
                                                setMinPurchaseForDisOnService(
                                                  event.target.value
                                                );
                                              }}
                                              disabled={
                                                selectedType !==
                                                "Discount On Service"
                                              }
                                            />
                                          </InputGroup>
                                        </FormGroup>
                                      </Col>
                                      <div className="">
                                        <Label for="description">
                                          Description (<i>max 70 characters</i>)
                                        </Label>
                                        <div>
                                          <CKEditor
                                            // key={descriptionForDisOnService}
                                            editor={ClassicEditor}
                                            data={descriptionForDisOnService}
                                            onChange={(event, editor) => {
                                              const data = editor.getData();
                                              let plainText = data.replace(
                                                /<[^>]*>/g,
                                                ""
                                              );
                                              if (plainText.length <= 70) {
                                                setDescriptionForDisOnService(
                                                  data
                                                );
                                              } else {
                                                editor.setData(
                                                  descriptionForBuy1get1
                                                );
                                              }
                                            }}
                                            disabled={
                                              selectedType !==
                                              "Discount On Service"
                                            }
                                          />
                                        </div>
                                      </div>
                                    </Row>
                                  </div>
                                </div>
                                <div>
                                  <div className="mt-3 d-flex">
                                    <Col md={4}>
                                      <RadioButton
                                        id="Discount On Parent Category"
                                        isSelected={
                                          selectedType ===
                                          "Discount On Parent Category"
                                        }
                                        value={"Discount On Parent Category"}
                                        label={"Discount On Parent Category"}
                                        changed={handleSelectType}
                                      />
                                    </Col>
                                  </div>
                                  <div
                                    className={`mt-2 p-3 border rounded ${
                                      selectedType !==
                                      "Discount On Parent Category"
                                        ? "discount_div_gray"
                                        : "discount_div_white"
                                    }`}
                                  >
                                    {/* <h6>First Order - Select Two Services</h6> */}
                                    <Row>
                                      <div className="d-flex align-items-center flex-wrap">
                                        <div className="d-flex align-items-center flex-wrap mb-3">
                                          {checkboxItemsForParentCategoryFilters()}
                                        </div>
                                        <div className="d-flex align-items-center flex-wrap mb-2">
                                          <div className="d-flex align-items-center flex-wrap">
                                            <i
                                              className="bx bxs-circle"
                                              style={{ color: "#0c9ab5" }}
                                            ></i>
                                            <p className="mb-0 ms-1">Male</p>
                                          </div>
                                          <div className="d-flex align-items-center flex-wrap ms-3">
                                            <i
                                              className="bx bxs-circle"
                                              style={{ color: "#dd0a6c" }}
                                            ></i>
                                            <p className="mb-0 ms-1">Female</p>
                                          </div>
                                        </div>
                                      </div>
                                      <Col md={4}>
                                        <FormGroup>
                                          <Label>Select Parent Category</Label>
                                          <Select
                                            name="serviceId"
                                            placeholder="Select..."
                                            value={parentCategoryId}
                                            onChange={event => {
                                              setParentCategoryId(event);
                                            }}
                                            options={parentCategories}
                                            isDisabled={
                                              selectedType !==
                                              "Discount On Parent Category"
                                            }
                                            getOptionLabel={e => (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "8px",
                                                }}
                                              >
                                                {/* Dynamic Dot Color */}
                                                <span
                                                  style={{
                                                    width: "10px",
                                                    height: "10px",
                                                    borderRadius: "50%",
                                                    backgroundColor: getColor(
                                                      e.type
                                                    ),
                                                    display: "inline-block",
                                                  }}
                                                ></span>
                                                {/* Service Name in Default Color */}
                                                <span
                                                  style={{ color: "inherit" }}
                                                >
                                                  {e.label}
                                                </span>
                                              </div>
                                            )}
                                            styles={{
                                              singleValue: provided => ({
                                                ...provided,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                              }),
                                              option: provided => ({
                                                ...provided,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                              }),
                                            }}
                                          />
                                          <Label className="statusValidation">
                                            {errors.type ? errors.type : ""}
                                          </Label>
                                        </FormGroup>
                                      </Col>

                                      <Col md={4}>
                                        <FormGroup>
                                          <Label for="discountType">
                                            Discount Type
                                          </Label>
                                          <Select
                                            id="discountType"
                                            options={DiscountTypeList || []}
                                            value={
                                              selectedDiscountTypeForDisOnParentCat
                                            }
                                            onChange={event => {
                                              handleSelectDiscountType(event);
                                              // handleChange("discountType")(
                                              //   event.value
                                              // );
                                              setSelectedDiscountTypeForDisOnParentCat(
                                                event
                                              );
                                            }}
                                            isDisabled={
                                              selectedType !==
                                              "Discount On Parent Category"
                                            }
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md={4}>
                                        <FormGroup>
                                          <Label for="discountAmount">
                                            Discount Amount/Percentage
                                          </Label>
                                          <InputGroup>
                                            {/* Prefix: INR or Percentage Symbol */}
                                            {selectedDiscountTypeForDisOnParentCat?.value !==
                                              "Percentage" && (
                                              <InputGroupText>
                                                INR
                                              </InputGroupText>
                                            )}

                                            <Input
                                              type="text"
                                              name="discountAmount"
                                              id="discountAmount"
                                              placeholder={
                                                selectedDiscountTypeForDisOnParentCat?.value ===
                                                "Percentage"
                                                  ? "Discount percentage"
                                                  : "Discount Amount"
                                              }
                                              value={
                                                selectedDiscountPercentageForDisOnParentCat
                                              }
                                              onChange={event => {
                                                // handleChange("discountAmount")(
                                                //   event.target.value
                                                // );
                                                setSelectedDiscountPercentageForDisOnParentCat(
                                                  event.target.value
                                                );
                                              }}
                                              disabled={
                                                selectedType !==
                                                "Discount On Parent Category"
                                              }
                                            />

                                            {/* Suffix: % Symbol if Percentage is selected */}
                                            {selectedDiscountTypeForDisOnParentCat?.value ===
                                              "Percentage" && (
                                              <InputGroupText>%</InputGroupText>
                                            )}
                                          </InputGroup>
                                        </FormGroup>
                                      </Col>
                                      <Col md={4}>
                                        <FormGroup>
                                          <Label for="minimumPurchase">
                                            Minimum Purchase Required
                                          </Label>
                                          <InputGroup>
                                            <InputGroupText>INR</InputGroupText>
                                            <Input
                                              type="text"
                                              name="minimumPurchase"
                                              id="minimumPurchase"
                                              placeholder="Minimum Purchase"
                                              value={
                                                minPurchaseForDisOnParentCat
                                              }
                                              onChange={event => {
                                                setMinPurchaseForDisOnParentCat(
                                                  event.target.value
                                                );
                                              }}
                                              disabled={
                                                selectedType !==
                                                "Discount On Parent Category"
                                              }
                                            />
                                          </InputGroup>
                                        </FormGroup>
                                      </Col>
                                      <div className="">
                                        <Label for="description">
                                          Description (<i>max 70 characters</i>)
                                        </Label>
                                        <div>
                                          <CKEditor
                                            // key={descriptionForDisOnService}
                                            editor={ClassicEditor}
                                            data={descriptionForDisOnParentCat}
                                            onChange={(event, editor) => {
                                              const data = editor.getData();
                                              let plainText = data.replace(
                                                /<[^>]*>/g,
                                                ""
                                              );
                                              if (plainText.length <= 70) {
                                                setDescriptionForDisOnParentCat(
                                                  data
                                                );
                                              } else {
                                                editor.setData(
                                                  descriptionForBuy1get1
                                                );
                                              }
                                            }}
                                            disabled={
                                              selectedType !==
                                              "Discount On Parent Category"
                                            }
                                          />
                                        </div>
                                      </div>
                                    </Row>
                                  </div>
                                </div>
                                <div>
                                  <div className="mt-3 d-flex">
                                    <Col md={4}>
                                      <RadioButton
                                        id="Discount On Category"
                                        isSelected={
                                          selectedType ===
                                          "Discount On Category"
                                        }
                                        value={"Discount On Category"}
                                        label={"Discount On Category"}
                                        changed={handleSelectType}
                                      />
                                    </Col>
                                  </div>
                                  <div
                                    className={`mt-2 p-3 border rounded ${
                                      selectedType !== "Discount On Category"
                                        ? "discount_div_gray"
                                        : "discount_div_white"
                                    }`}
                                  >
                                    {/* <h6>First Order - Select Two Services</h6> */}
                                    <Row>
                                      <div className="d-flex align-items-center flex-wrap">
                                        <div className="d-flex align-items-center flex-wrap mb-3">
                                          {checkboxItemsForCategoryFilters()}
                                        </div>
                                        <div className="d-flex align-items-center flex-wrap mb-2">
                                          <div className="d-flex align-items-center flex-wrap">
                                            <i
                                              className="bx bxs-circle"
                                              style={{ color: "#0c9ab5" }}
                                            ></i>
                                            <p className="mb-0 ms-1">Male</p>
                                          </div>
                                          <div className="d-flex align-items-center flex-wrap ms-3">
                                            <i
                                              className="bx bxs-circle"
                                              style={{ color: "#dd0a6c" }}
                                            ></i>
                                            <p className="mb-0 ms-1">Female</p>
                                          </div>
                                        </div>
                                      </div>
                                      <Col md={4}>
                                        <FormGroup>
                                          <Label>Select Category</Label>
                                          <Select
                                            name="serviceId"
                                            placeholder="Select..."
                                            value={categoryId}
                                            onChange={event => {
                                              setCategoryId(event);
                                            }}
                                            options={Categories}
                                            isDisabled={
                                              selectedType !==
                                              "Discount On Category"
                                            }
                                            getOptionLabel={e => (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  gap: "8px",
                                                }}
                                              >
                                                {/* Dynamic Dot Color */}
                                                <span
                                                  style={{
                                                    width: "10px",
                                                    height: "10px",
                                                    borderRadius: "50%",
                                                    backgroundColor: getColor(
                                                      e.type
                                                    ),
                                                    display: "inline-block",
                                                  }}
                                                ></span>
                                                {/* Service Name in Default Color */}
                                                <span
                                                  style={{ color: "inherit" }}
                                                >
                                                  {e.label}
                                                </span>
                                              </div>
                                            )}
                                            styles={{
                                              singleValue: provided => ({
                                                ...provided,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                              }),
                                              option: provided => ({
                                                ...provided,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                              }),
                                            }}
                                          />
                                          <Label className="statusValidation">
                                            {errors.type ? errors.type : ""}
                                          </Label>
                                        </FormGroup>
                                      </Col>

                                      <Col md={4}>
                                        <FormGroup>
                                          <Label for="discountType">
                                            Discount Type
                                          </Label>
                                          <Select
                                            id="discountType"
                                            options={DiscountTypeList || []}
                                            value={
                                              selectedDiscountTypeForDisOnCategory
                                            }
                                            onChange={event => {
                                              handleSelectDiscountType(event);
                                              setSelectedDiscountTypeForDisOnCategory(
                                                event
                                              );
                                            }}
                                            isDisabled={
                                              selectedType !==
                                              "Discount On Category"
                                            }
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md={4}>
                                        <FormGroup>
                                          <Label for="discountAmount">
                                            Discount Amount/Percentage
                                          </Label>
                                          <InputGroup>
                                            {/* Prefix: INR or Percentage Symbol */}
                                            {selectedDiscountTypeForDisOnCategory?.value !==
                                              "Percentage" && (
                                              <InputGroupText>
                                                INR
                                              </InputGroupText>
                                            )}

                                            <Input
                                              type="text"
                                              name="discountAmount"
                                              id="discountAmount"
                                              placeholder={
                                                selectedDiscountTypeForDisOnCategory?.value ===
                                                "Percentage"
                                                  ? "Discount percentage"
                                                  : "Discount Amount"
                                              }
                                              value={
                                                selectedDiscountPercentageForDisOnCategory
                                              }
                                              onChange={event => {
                                                // handleChange("discountAmount")(
                                                //   event.target.value
                                                // );
                                                setSelectedDiscountPercentageForDisOnCategory(
                                                  event.target.value
                                                );
                                              }}
                                              disabled={
                                                selectedType !==
                                                "Discount On Category"
                                              }
                                            />

                                            {/* Suffix: % Symbol if Percentage is selected */}
                                            {selectedDiscountTypeForDisOnService?.value ===
                                              "Percentage" && (
                                              <InputGroupText>%</InputGroupText>
                                            )}
                                          </InputGroup>
                                        </FormGroup>
                                      </Col>
                                      <Col md={4}>
                                        <FormGroup>
                                          <Label for="minimumPurchase">
                                            Minimum Purchase Required
                                          </Label>
                                          <InputGroup>
                                            <InputGroupText>INR</InputGroupText>
                                            <Input
                                              type="text"
                                              name="minimumPurchase"
                                              id="minimumPurchase"
                                              placeholder="Minimum Purchase"
                                              value={
                                                minPurchaseForDisOnCategory
                                              }
                                              onChange={event => {
                                                setMinPurchaseForDisOnCategory(
                                                  event.target.value
                                                );
                                              }}
                                              disabled={
                                                selectedType !==
                                                "Discount On Category"
                                              }
                                            />
                                          </InputGroup>
                                        </FormGroup>
                                      </Col>
                                      <div className="">
                                        <Label for="description">
                                          Description (<i>max 70 characters</i>)
                                        </Label>
                                        <div>
                                          <CKEditor
                                            // key={descriptionForDisOnService}
                                            editor={ClassicEditor}
                                            data={descriptionForDisOnCategory}
                                            onChange={(event, editor) => {
                                              const data = editor.getData();
                                              let plainText = data.replace(
                                                /<[^>]*>/g,
                                                ""
                                              );
                                              if (plainText.length <= 70) {
                                                setDescriptionForDisOnCategory(
                                                  data
                                                );
                                              } else {
                                                editor.setData(
                                                  descriptionForBuy1get1
                                                );
                                              }
                                            }}
                                            disabled={
                                              selectedType !==
                                              "Discount On Category"
                                            }
                                          />
                                        </div>
                                      </div>
                                    </Row>
                                  </div>
                                </div>
                                <div>
                                  <div className="mt-3">
                                    <Col md={3}>
                                      <RadioButton
                                        id="General"
                                        isSelected={selectedType === "General"}
                                        value={"General"}
                                        label={"General"}
                                        changed={handleSelectType}
                                      />
                                    </Col>
                                  </div>
                                  <div
                                    className={`mt-2 p-3 border rounded ${
                                      selectedType !== "General"
                                        ? "discount_div_gray"
                                        : "discount_div_white"
                                    }`}
                                  >
                                    {/* <h6>First Order - Select Two Services</h6> */}
                                    <Row>
                                      <Col md={4}>
                                        <FormGroup>
                                          <Label for="discountType">
                                            Discount Type
                                          </Label>
                                          <Select
                                            id="discountType"
                                            options={DiscountTypeList || []}
                                            value={
                                              selectedDiscountTypeForGeneral
                                            }
                                            onChange={event => {
                                              handleSelectDiscountType(event);
                                              setSelectedDiscountTypeForGeneral(
                                                event
                                              );
                                            }}
                                            isDisabled={
                                              selectedType !== "General"
                                            }
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md={4}>
                                        <FormGroup>
                                          <Label for="discountAmount">
                                            Discount Amount/Percentage
                                          </Label>
                                          <InputGroup>
                                            {selectedDiscountTypeForGeneral?.value !==
                                              "Percentage" && (
                                              <InputGroupText>
                                                INR
                                              </InputGroupText>
                                            )}

                                            <Input
                                              type="text"
                                              name="discountAmount"
                                              id="discountAmount"
                                              placeholder={
                                                selectedDiscountTypeForGeneral?.value ===
                                                "Percentage"
                                                  ? "Discount percentage"
                                                  : "Discount Amount"
                                              }
                                              value={
                                                selectedDiscountPercentageForGeneral
                                              }
                                              onChange={event => {
                                                setSelectedDiscountPercentageForGeneral(
                                                  event.target.value
                                                );
                                              }}
                                              disabled={
                                                selectedType !== "General"
                                              }
                                            />
                                            {selectedDiscountTypeForGeneral?.value ===
                                              "Percentage" && (
                                              <InputGroupText>%</InputGroupText>
                                            )}
                                          </InputGroup>
                                        </FormGroup>
                                      </Col>
                                      <Col md={4}>
                                        <FormGroup>
                                          <Label for="minimumPurchase">
                                            Minimum Purchase Required
                                          </Label>
                                          <InputGroup>
                                            <InputGroupText>INR</InputGroupText>
                                            <Input
                                              type="text"
                                              name="minimumPurchase"
                                              id="minimumPurchase"
                                              placeholder="Minimum Purchase"
                                              value={minPurchaseForGeneral}
                                              onChange={event => {
                                                setMinPurchaseForGeneral(
                                                  event.target.value
                                                );
                                              }}
                                              disabled={
                                                selectedType !== "General"
                                              }
                                            />
                                          </InputGroup>
                                        </FormGroup>
                                      </Col>
                                      <div className="">
                                        <Label for="description">
                                          Description (<i>max 70 characters</i>)
                                        </Label>
                                        <div>
                                          <CKEditor
                                            editor={ClassicEditor}
                                            data={descriptionForGeneral}
                                            onChange={(event, editor) => {
                                              const data = editor.getData();
                                              let plainText = data.replace(
                                                /<[^>]*>/g,
                                                ""
                                              );
                                              if (plainText.length <= 70) {
                                                setDescriptionForGeneral(data);
                                              } else {
                                                editor.setData(
                                                  descriptionForBuy1get1
                                                );
                                              }
                                            }}
                                            disabled={
                                              selectedType !== "General"
                                            }
                                          />
                                        </div>
                                      </div>
                                    </Row>
                                  </div>
                                </div>
                              </div>
                              <div className="mt-3">
                                <Label for="whereUsed">Notes</Label>
                                <Card>
                                  <CKEditor
                                    editor={ClassicEditor}
                                    data={values?.whereUsed || ""}
                                    onChange={(event, editor) => {
                                      const data = editor.getData();
                                      handleChange("whereUsed")(data);
                                    }}
                                  />
                                </Card>
                              </div>
                              <Row>
                                <Col md={6} className="mt-2">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="validationCustom06">
                                      Coupon Logo (
                                      <i>Used to display in service page</i>)
                                    </Label>
                                    <Dropzone
                                      onDrop={async acceptedFiles => {
                                        acceptedFiles.map(file =>
                                          Object.assign(file, {
                                            preview: URL.createObjectURL(file),
                                            formattedSize: formatBytes(
                                              file.size
                                            ),
                                          })
                                        );

                                        const imgUrl = await getImageUrl({
                                          image: acceptedFiles,
                                        });
                                        setLogo(imgUrl);
                                      }}
                                    >
                                      {({ getRootProps, getInputProps }) => (
                                        <div className="dropzone image_drop">
                                          <div
                                            className="dz-message needsclick"
                                            {...getRootProps()}
                                          >
                                            <input {...getInputProps()} />
                                            <div className="">
                                              <i className="display-6 text-muted bx bxs-cloud-upload" />
                                            </div>
                                            <h6>
                                              Drop files here or click to
                                              upload.
                                            </h6>
                                          </div>
                                        </div>
                                      )}
                                    </Dropzone>

                                    <div
                                      className="dropzone-previews mt-3"
                                      id="file-previews"
                                    >
                                      {logo && (
                                        <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                                          <div className="p-2">
                                            <Row className="align-items-center">
                                              <Col className="col-auto">
                                                <ProfileImage
                                                  image={logo}
                                                  height="80"
                                                  classNames="avatar-sm rounded bg-light"
                                                />
                                              </Col>
                                              <Col>
                                                <Button
                                                  color="danger"
                                                  size="sm"
                                                  onClick={() => setLogo(null)}
                                                >
                                                  Remove
                                                </Button>
                                              </Col>
                                            </Row>
                                          </div>
                                        </Card>
                                      )}
                                    </div>
                                  </FormGroup>
                                </Col>
                                <Col md={6} className="mt-2">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="validationCustom06">
                                      Coupon Banner (<i>WebPage</i>)
                                    </Label>
                                    <Dropzone
                                      onDrop={async acceptedFiles => {
                                        acceptedFiles.map(file =>
                                          Object.assign(file, {
                                            preview: URL.createObjectURL(file),
                                            formattedSize: formatBytes(
                                              file.size
                                            ),
                                          })
                                        );

                                        const imgUrl = await getImageUrl({
                                          image: acceptedFiles,
                                        });
                                        setWebpageBanner(imgUrl);
                                      }}
                                    >
                                      {({ getRootProps, getInputProps }) => (
                                        <div className="dropzone image_drop">
                                          <div
                                            className="dz-message needsclick"
                                            {...getRootProps()}
                                          >
                                            <input {...getInputProps()} />
                                            <div className="">
                                              <i className="display-6 text-muted bx bxs-cloud-upload" />
                                            </div>
                                            <h6>
                                              Drop files here or click to
                                              upload.
                                            </h6>
                                          </div>
                                        </div>
                                      )}
                                    </Dropzone>

                                    <div
                                      className="dropzone-previews mt-3"
                                      id="file-previews"
                                    >
                                      {webpageBanner && (
                                        <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                                          <div className="p-2">
                                            <Row className="align-items-center">
                                              <Col className="col-auto">
                                                <ProfileImage
                                                  image={webpageBanner}
                                                  height="80"
                                                  classNames="avatar-sm rounded bg-light"
                                                />
                                              </Col>
                                              <Col>
                                                <Button
                                                  color="danger"
                                                  size="sm"
                                                  onClick={() =>
                                                    setWebpageBanner(null)
                                                  }
                                                >
                                                  Remove
                                                </Button>
                                              </Col>
                                            </Row>
                                          </div>
                                        </Card>
                                      )}
                                    </div>
                                  </FormGroup>
                                </Col>
                                <Col md={6} className="mt-2">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="validationCustom06">
                                      Coupon Banner(<i>Mobile</i>)
                                    </Label>
                                    <Dropzone
                                      onDrop={async acceptedFiles => {
                                        acceptedFiles.map(file =>
                                          Object.assign(file, {
                                            preview: URL.createObjectURL(file),
                                            formattedSize: formatBytes(
                                              file.size
                                            ),
                                          })
                                        );

                                        const imgUrl = await getImageUrl({
                                          image: acceptedFiles,
                                        });
                                        setMobilebanner(imgUrl);
                                      }}
                                    >
                                      {({ getRootProps, getInputProps }) => (
                                        <div className="dropzone image_drop">
                                          <div
                                            className="dz-message needsclick"
                                            {...getRootProps()}
                                          >
                                            <input {...getInputProps()} />
                                            <div className="">
                                              <i className="display-6 text-muted bx bxs-cloud-upload" />
                                            </div>
                                            <h6>
                                              Drop files here or click to
                                              upload.
                                            </h6>
                                          </div>
                                        </div>
                                      )}
                                    </Dropzone>

                                    <div
                                      className="dropzone-previews mt-3"
                                      id="file-previews"
                                    >
                                      {mobilebanner && (
                                        <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete">
                                          <div className="p-2">
                                            <Row className="align-items-center">
                                              <Col className="col-auto">
                                                <ProfileImage
                                                  image={mobilebanner}
                                                  height="80"
                                                  classNames="avatar-sm rounded bg-light"
                                                />
                                              </Col>
                                              <Col>
                                                <Button
                                                  color="danger"
                                                  size="sm"
                                                  onClick={() =>
                                                    setMobilebanner(null)
                                                  }
                                                >
                                                  Remove
                                                </Button>
                                              </Col>
                                            </Row>
                                          </div>
                                        </Card>
                                      )}
                                    </div>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </Row>
                            <hr></hr>
                            <div className="d-flex justify-content-end">
                              <Button
                                color="light"
                                className="w-md btn-sm me-3"
                                onClick={leaveToList}
                              >
                                Cancel
                              </Button>
                              {!coupondata ? (
                                <Button
                                  color="primary"
                                  type="submit"
                                  className="w-md btn-sm"
                                  onClick={() => {
                                    onSubmit(values);
                                  }}
                                >
                                  Submit
                                </Button>
                              ) : (
                                <Button
                                  color="primary"
                                  className="w-md btn-sm"
                                  type="submit"
                                  onClick={() => {
                                    onSubmit(values);
                                  }}
                                >
                                  Save Changes
                                </Button>
                              )}
                            </div>
                          </Form>
                        );
                      }}
                    </Formik>
                  </CardBody>
                </Card>
              </div>
            </div>
          </Container>
        </ModalBody>
      </Modal>
      <Spinner loading={loading} />
      {success_msg ? successPopup() : null}
      {error_msg ? errorPopup() : null}
    </>
  );
};

export default CreateCoupon;
